import { request } from '@koi-design/vix-tools';
import { packApi } from '@/libs/tools';

export function getCompanyUserPermissionApi(data) {
  return request({
    url: '/api/api-user/tenant_user_center_permission/get_auth/',
    method: 'post',
    data
  });
}

export function getCompanyUserLastPermissionApi(data) {
  return request({
    url: '/api/api-user/tenant_user_center_permission/get_permission/',
    method: 'get',
    data
  });
}

export function getHomelandPermissionApi(data) {
  return request({
    url: '/api/api-user/homeland/homeland_per/get/',
    method: 'get',
    data
  });
}
export function getHomelandAgentPermissionApi(data) {
  return request({
    url: '/api/api-user/homeland/agent_per/get/',
    method: 'get',
    data
  });
}
export function getHomelandResourcePermissionApi(data) {
  return request({
    url: '/api/api-user/homeland/resource_per/get/',
    method: 'get',
    data
  });
}
export function addHomelandPermissionApi(data) {
  return packApi(
    {
      url: '/api/api-user/homeland/homeland_per/add/',
      method: 'post',
      data
    },
    'other'
  );
}
export function addHomelandAgentPermissionApi(data) {
  return packApi(
    {
      url: '/api/api-user/homeland/agent_per/add/',
      method: 'post',
      data
    },
    'other'
  );
}
export function addHomelandResourcePermissionApi(data) {
  return packApi(
    {
      url: '/api/api-user/homeland/resource_per/add/',
      method: 'post',
      data
    },
    'other'
  );
}

export function renewHomelandPermissionApi(data) {
  return packApi({
    url: '/api/api-user/homeland/homeland_per/renew/',
    method: 'post',
    data
  });
}
export function renewHomelandAgentPermissionApi(data) {
  return packApi({
    url: '/api/api-user/homeland/agent_per/renew/',
    method: 'post',
    data
  });
}
export function renewHomelandResourcePermissionApi(data) {
  return packApi({
    url: '/api/api-user/homeland/resource_per/renew/',
    method: 'post',
    data
  });
}
export function deleteHomelandPermissionApi(data) {
  return packApi({
    url: '/api/api-user/homeland/homeland_per/delete/',
    method: 'post',
    data
  });
}

export function deleteHomelandAgentPermissionApi(data) {
  return packApi({
    url: '/api/api-user/homeland/agent_per/delete/',
    method: 'post',
    data
  });
}

export function deleteHomelandResourcePermissionApi(data) {
  return packApi({
    url: '/api/api-user/homeland/resource_per/delete/',
    method: 'post',
    data
  });
}

export function getBoundResourcePermissionApi(data) {
  return request({
    url: '/api/api-user/homeland/agent_per/bound_resource/',
    method: 'get',
    data
  });
}

export function getCompanyUserListApi(data) {
  return request({
    url: '/api/api-user/ucenter/user_list/',
    method: 'post',
    data
  });
}
